import styled from 'styled-components';

export const StatusBarWrapper = styled.div`
  position: fixed;
  bottom: 0px;
  background: rgb(255, 255, 255);
  width: 100%;
  left: 0px;
  padding: 0.5rem 1rem;
  border-top: 5px solid rgb(75, 40, 109);
  z-index: 1;
`;

export const BoxWrapper = styled.div`
  display: flex;
  padding: 0.25rem 0;
  gap: 10px;
`;
